import * as moment from "moment";

export default {
    init () {
        var stopId = parseInt($('#timetables').data('stop'));
        setInterval(function () {
            $.ajax({
                url: ajaxurl,
                method: 'POST',
                data: {
                    action: 'update_departures',
                    stop_id: stopId,
                },
                success: function(data) {
                    if (data) {
                        var template = "";
                        var d = JSON.parse(data);
                        JSON.parse(data).forEach(function(item) {
                            template += `<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <div class="dest-column">
                            <h3 style="background-color: ${item.stop_info.color}; color: ${item.stop_info.text_color};">${item.stop.post_title}</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Departs</th>
                                        <th>Arrives</th>
                                    </tr>
                                </thead>
                                <tbody>`;
                            if (item.routes) {
                                console.log(item.stop_color_rgba);
                                item.routes.forEach(function(time, i) {
                                    var bgcolor = ``;
                                    if (i % 2 === 1) {
                                        bgcolor = " style='background-color: rgba("+item.stop_color_rgba[0]+", "+item.stop_color_rgba[1]+", "+item.stop_color_rgba[2]+", 0.15)'";
                                        console.log(bgcolor);
                                    }
                                    template += `<tr>
                                                <td${bgcolor}>${time.departure_time}</td>
                                                <td${bgcolor}>${time.arrival_time}</td>
                                            </tr>`
                                });
                            } else {
                                template += `<tr>
                                            <td colspan="2">
                                                No more departures for today.
                                            </td>
                                        </tr>`;
                            }
                                template += `</tbody>
                            </table>
                        </div>
                    </div>`;
                        });
                        $('#schedule-row').html(template);
                    }
                },
            });
            var datetime = moment();
            $('.datetime .date').text(datetime.format('M/D/YY'));
            $('.datetime .time').text(datetime.format('h:mm a'));
        }, 30000);
    },
}


// WEBPACK FOOTER //
// ./scripts/routes/schedule.js